import React, { Fragment, useState } from 'react'
import axios from 'axios'
import classNames from 'classnames'


export function BoxHeaderItem(props) {
  return (
    <li className="active">
      <a href="#">
        {props.label}
      </a>
    </li>
  )
}

export function BoxHeader(props) {
  return (
    <header role="heading">
      <ul id="tab" className="nav nav-tabs">
        {props.children}
      </ul>
    </header>
  )
}
export function BoxContent(props) {
  return (
    <div role="content">
      <div className="widget-body">
        {props.children}
      </div>
    </div>
  )
}


export default function Box(props) {
  const activeTab = useState("agenda")
  
  return (
     <div className="jarviswidget">
      {props.children}
    </div>
  )
}